import React from "react";
import {Button, Carousel, Col, Row} from "antd";
import ReactGA from "react-ga";
import { useMediaQuery } from 'react-responsive'
import data from "./data";
import {RightOutlined} from "@ant-design/icons";

const Banner : React.FC = () => {

    const isTabletDown  = useMediaQuery({  query : "(max-width: 767px)"});
    const isPhoneDown   = useMediaQuery({  query : "(max-width: 480px)"});

    return (
        <section className={"main-banner"}>
           <div className={"public-container"}>
               <Row gutter={[50, 30]} className={"describe"}>
                   <Col md={{push : 13, span : 11}}  sm={24} xs={24}>
                       <div className={"sub-banner"}>
                            <img src={"/images/banner/home-banner.svg"} alt={"WASDLABS BANNER"} />
                       </div>
                   </Col>
                   <Col md={{pull : 11, span : 13}} sm={24} xs={24} className={"carousel-section"}>
                       <Carousel
                           dotPosition={ isPhoneDown || isTabletDown ? "bottom" : "left"}
                           dots={{className : "cr-dots"}}
                           autoplay={true}
                           autoplaySpeed={3000}
                       >
                           {
                               data.banner.id.map((item, x ) => (
                                   <div key={item.title} className={`section-heading child-${x}`}>
                                       <h1 className={"title"}>{item.title}</h1>
                                       <p className={"subtitle"}>{item.subTitle}</p>
                                       {
                                           item.buttonType === "call"
                                               ? (
                                                   <Button
                                                       type={"primary"}
                                                       size={"large"}
                                                       href={"https://wa.me/6285656284641"}
                                                       target={"_blank"}
                                                       rel={"noreferrer"}
                                                       onClick={() => ReactGA.event({category : "Contact", action : "clicked", label : "consultation" })}
                                                   >
                                                       {item.buttonText} <RightOutlined />
                                                   </Button>
                                               ) : (
                                                   <Button
                                                       href={"/project"}
                                                       type={"primary"}
                                                       size={"large"}
                                                       onClick={() => ReactGA.event({category : "Portofolio", action : "clicked", label : "view_more" })}
                                                   >
                                                       {item.buttonText} <RightOutlined />
                                                   </Button>
                                               )
                                       }
                                   </div>
                               ))
                           }
                       </Carousel>
                   </Col>
               </Row>
           </div>
        </section>
    )
}

export default React.memo(Banner);